module.exports = __webpack_public_path__ + "img/NR.3e36fce5.png";